<template>
  <select v-bind:value="value" class="modal-select" v-on:change="$emit('input', parseInt($event.target.value))">
    <option v-for="option in timeOptions" v-bind:value="option.value" v-bind:key="option.text">
      {{ option.text }}
    </option>
  </select>
 </template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: function () {
        return 60
      }
    }
  },
  computed: {
    timeOptions: function () {
      const a = []
      for (var i = 0; i < 24 * 60; i += 15) {
        if (i > 0) {
          a.push({
            text: (i / 60 >= 1 ? Math.floor(i / 60) + this.$t('tour_hour_label') : "") + (i % 60 !== 0 ? String(i % 60) + this.$t('tour_minute_label') : ""),
            value: String(i),
          });
        }
      }
      return a
    }
  }
}
</script>
